import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { useNotifications } from "@toolpad/core";
import React, { useState } from "react";
import { changePassword } from "../services/userService";
import ConfirmationModal from "./modal/ConfirmationModal";

export default function ChangePasswordModal({ setVisible }) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const notifications = useNotifications();
  const [error, setError] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Hesla se neshodují");
      return;
    }
    // TODO add password validation
    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmed = async () => {
    const result = await changePassword(
      oldPassword,
      newPassword,
      confirmPassword
    );

    if (result.success) {
      setConfirmModalOpen(false);
      setVisible(false);
      setError("");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      notifications.show("Heslo bylo úspěšně změněno", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      setError(result.message || "Neznámá chyba.");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  return (
    <Box component="form" onSubmit={onSubmit}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Změna hesla
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {/* <Typography variant="body1" sx={{ mb: 1 }}></Typography> */}
      <TextField
        type="password"
        label="Staré heslo"
        variant="outlined"
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
        required
        autoComplete="off"
      />

      <Typography variant="body1" sx={{ mb: 1 }}></Typography>
      <TextField
        type="password"
        label="Nové heslo"
        variant="outlined"
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        required
        autoComplete="off"
      />

      <Typography variant="body1" sx={{ mb: 1 }}></Typography>
      <TextField
        type="password"
        label="Nové heslo znovu"
        variant="outlined"
        size="small"
        fullWidth
        sx={{ mb: 2 }}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
        autoComplete="off"
      />

      <Button
        type="submit"
        variant="contained"
        sx={{ display: "block", width: "fit-content", margin: "0 auto" }}
      >
        Uložit
      </Button>
      {confirmModalOpen && (
        <ConfirmationModal
          visible={confirmModalOpen}
          setVisible={setConfirmModalOpen}
          title="Potvrzení změny"
          message={`Opravdu si přejete změnit heslo`}
          onConfirm={handleSubmitConfirmed}
        />
      )}
    </Box>
  );
}
